import { render } from "./EyeIcon.vue?vue&type=template&id=4c0dc15b"
import script from "./EyeIcon.vue?vue&type=script&lang=ts"
export * from "./EyeIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script